/**
 * iOS Safari auto-zooms the page when a focused input has a font-size below
 * 16px. Capping maximum-scale suppresses that auto-zoom, and since iOS 10
 * Safari still honors user pinch-zoom regardless of maximum-scale, so
 * accessibility is unaffected. Applied only on iOS because some Android
 * browsers would actually lose pinch-zoom from the same cap.
 */
export function preventIosInputZoom() {
  const isIos =
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    // iPadOS 13+ reports itself as Macintosh; touch support reveals the iPad
    (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1);
  if (!isIos) return;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  // No viewport meta (possible on embed host pages) means the page renders
  // desktop-scaled already; injecting one would reflow the whole host page.
  // An existing maximum-scale is the page author's choice — leave it alone.
  if (!meta || /maximum-scale/i.test(meta.content)) return;

  meta.content = `${meta.content}, maximum-scale=1.0`;
}
